import { MoreOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { List, ButtonProps, Divider, DividerProps } from 'antd';
import Button from 'app/components/Button';
import Popover from 'app/components/Popover';
import React from 'react';

type DividerExtraProps = {
  type: 'divider';
  extraProps?: DividerProps;
};
type ButtonExtraProps = {
  type?: undefined;
  extraProps?: ButtonProps;
};
type Action = {
  label: string;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  key: string;
};
type MoreMenuProps = {
  actions: Array<(Action & DividerExtraProps) | (Action & ButtonExtraProps)>;
  className?: any;
  children?: React.ReactNode;
};

const StyledPopover = styled(Popover)`
  .ant-popover-inner {
    border-radius: 12px;
  }
  .ant-popover-inner-content {
    min-width: 160px;
    padding: 0;
    .ant-list-item {
      border-bottom: 0px;
      padding: 0;
    }
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

const StyledDefaultAction = styled(Button)`
  height: 45px;
  width: 100%;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.001em;
  text-align: left;
  color: #232b3a;

  &:hover {
    background: #f6f9ff;
  }
  &.ant-btn-dangerous.ant-btn-text:hover {
    background: #fff2f2;
  }
`;

const MoreMenu = (props: MoreMenuProps & { overlayClassName?: any }) => {
  const { actions, className } = props;

  return (
    <StyledPopover
      overlayClassName={className}
      trigger="click"
      showArrow={false}
      placement="bottom"
      content={
        <List bordered={false}>
          {actions.map(({ key, type, label, prefix, extraProps }, index) => {
            if (type === 'divider') {
              return (
                <Divider
                  key={index}
                  {...(extraProps as DividerProps)}
                ></Divider>
              );
            }
            return (
              <List.Item key={key}>
                <StyledDefaultAction
                  type="text"
                  icon={prefix}
                  {...(extraProps as ButtonProps)}
                >
                  {label}
                </StyledDefaultAction>
              </List.Item>
            );
          })}
        </List>
      }
    >
      {props.children ? props.children : <MoreOutlined />}
    </StyledPopover>
  );
};

export default MoreMenu;
